import { useEffect, useState } from "react";
import { apiClient } from "../lib/api";
import CarCard from "../components/CarCard";
import Seo from "../components/Seo";
import { Search } from "lucide-react";

const Cars = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("newest");

  useEffect(() => {
    setLoading(true);
    apiClient
      .get("/cars", { params: { limit: 200 } })
      .then((r) => setItems(r.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  const filtered = items
    .filter((c) => {
      const q = search.toLowerCase().trim();
      if (!q) return true;
      return (
        c.brand?.toLowerCase().includes(q) ||
        c.model?.toLowerCase().includes(q) ||
        String(c.year).includes(q)
      );
    })
    .sort((a, b) => {
      if (sort === "price-asc") return a.price - b.price;
      if (sort === "price-desc") return b.price - a.price;
      if (sort === "year-desc") return b.year - a.year;
      return new Date(b.created_at) - new Date(a.created_at);
    });

  return (
    <div data-testid="cars-page" className="bg-zinc-950 text-white pt-32 pb-24 min-h-screen">
      <Seo
        title="İkinci El Araçlar"
        description="İstanbul'da ekspertizden geçmiş, güvenilir ikinci el araç ilanları. Gensan Motors'ta uygun fiyatlı 2. el otomobil seçeneklerini inceleyin."
        keywords="ikinci el araç, ikinci el araba İstanbul, 2. el otomobil, sahibinden ikinci el araç"
        path="/ikinci-el-araclar"
      />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <span className="block h-px w-12 bg-orange-500" />
            <span className="text-orange-500 font-bold uppercase tracking-[0.3em] text-xs">İkinci El</span>
          </div>
          <h1 className="font-display text-5xl md:text-7xl font-bold uppercase leading-none tracking-tight">
            İkinci El <span className="text-orange-500">Araçlar</span>
          </h1>
          <p className="mt-6 text-zinc-400 max-w-2xl text-lg">
            Ekspertizden geçmiş, güvenilir ikinci el araç stoğumuzu inceleyin.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-4 mb-10 border-y border-zinc-900 py-5">
          <div className="relative flex-1">
            <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500" />
            <input
              data-testid="car-search-input"
              type="text"
              placeholder="Marka, model veya yıl ara..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full bg-transparent border border-zinc-800 hover:border-zinc-700 focus:border-orange-500 outline-none pl-12 pr-4 py-3 text-sm uppercase tracking-wide placeholder:text-zinc-600 transition-colors"
            />
          </div>
          <select
            data-testid="car-sort-select"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            className="bg-transparent border border-zinc-800 hover:border-zinc-700 focus:border-orange-500 outline-none px-4 py-3 text-sm uppercase tracking-wide text-white cursor-pointer transition-colors"
          >
            <option value="newest" className="bg-black">En Yeni</option>
            <option value="price-asc" className="bg-black">Fiyat ↑</option>
            <option value="price-desc" className="bg-black">Fiyat ↓</option>
            <option value="year-desc" className="bg-black">Yıl ↓</option>
          </select>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
              <div key={i} className="aspect-[4/3] bg-zinc-900 animate-pulse" />
            ))}
          </div>
        ) : filtered.length === 0 ? (
          <div className="border border-zinc-900 p-20 text-center">
            <p className="text-zinc-400 uppercase tracking-widest text-sm">
              {items.length === 0 ? "Henüz araç eklenmedi" : "Aramanıza uygun araç bulunamadı"}
            </p>
          </div>
        ) : (
          <>
            <div className="mb-6 text-sm uppercase tracking-widest text-zinc-500">
              {filtered.length} sonuç bulundu
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {filtered.map((c, i) => (
                <CarCard key={c.id} car={c} index={i} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Cars;
